var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 25,
    viewBox: "0 0 2 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.09131 0.65271C1.09131 0.376568 0.867451 0.15271 0.591309 0.15271C0.315166 0.15271 0.0913086 0.376568 0.0913086 0.65271H1.09131ZM0.0913086 0.65271V24.6527H1.09131V0.65271H0.0913086Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDivider);
export default __webpack_public_path__ + "static/media/ic_divider.fe83ebe1ea3a018de0f9adfb941c3d68.svg";
export { ForwardRef as ReactComponent };